import { render } from "./AccessRole.vue?vue&type=template&id=7f3ec291&ts=true"
import script from "./AccessRole.vue?vue&type=script&lang=ts"
export * from "./AccessRole.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__